interface SatisfiedTileLabelInput {
  satisfiedByFilename?: string;
  /** Further documents satisfying the tile beyond the one named. */
  satisfiedByAdditionalCount?: number;
}

/**
 * "Met by <filename> +N" (or "Received" when no filename resolved) for a
 * satisfied forecast/upload tile. Shared by `IntakeForecastPage` and
 * `IntakeDocumentsPage` so the two surfaces render identical text for the
 * same satisfaction data instead of maintaining two copies of this string.
 */
export function satisfiedTileLabel({
  satisfiedByFilename,
  satisfiedByAdditionalCount,
}: SatisfiedTileLabelInput): string {
  if (!satisfiedByFilename) return 'Received';
  return `Met by ${satisfiedByFilename}${
    satisfiedByAdditionalCount ? ` +${satisfiedByAdditionalCount}` : ''
  }`;
}
